export default __webpack_public_path__ + "static/uvprotected-cbbf87b80bbc96a1b91ceb625865c66a.jpg";